import { render } from "./Start_pack.vue?vue&type=template&id=55db3278"
import script from "./Start_pack.vue?vue&type=script&lang=js"
export * from "./Start_pack.vue?vue&type=script&lang=js"

import "./Start_pack.vue?vue&type=style&index=0&id=55db3278&lang=scss"

import exportComponent from "G:\\司机仓库\\warehouseModule\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__